import { useDispatch, useSelector } from 'react-redux';
import HeaderSession from '../../utils/headerSession'
import RegisterAccess from '../../utils/registerAccess'
import ButtonSwitchSistem from './buttonSwitchSistem'
import { useEffect, useState } from 'react';
import api from '../../services/api';
import { Divider, Typography } from '@mui/material';
import GestQuota from '../departamentos/dmts/importacaoExportacao/gestQuota';
import VerifyPermission from '../../utils/verifyPermission';
import { temPermissao } from '../../utils/permissoes';
import { useNavigate } from 'react-router-dom';


export default function Definicoes() {
    const user = useSelector(state => state.account.user);
    const [definicoesSistema, setDefinicoesSistema] = useState('')
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (temPermissao(user, ['definicoesSistema'])) {
        } else {
            dispatch({
                type: "alert",
                payload: { alert: "Acesso negado" },
            });
            navigate("/admin/menu");
        }

        api.get(`/definicoes/sistema/all`)
            .then(response => {
                setDefinicoesSistema(response.data.definicoesSistema[0]);
            }).catch(err => '')
    }, [])

    const Header = ({ header }) => { return (<Typography m={1}> <b>{header}</b> </Typography>) }
    return (
        <>
            <RegisterAccess page={''} />
            <HeaderSession title={'DEFINIÇÕES DE SISTEMA'} />

            <Header header={'SECÇÕES DO SITE'} />
            {/* <ButtonSwitchSistem
                url={'/definicoes/sistema/seccoes'}
                definicao={'servicos'}
                definicoes={definicoesSistema?.seccoes}
                setdefinicoes={setDefinicoesSistema}
                title={'Desabilitar/Habilitar servicos'}
                descricao={''}
            /> */}
            <ButtonSwitchSistem
                url={'/definicoes/sistema/seccoes'}
                definicao={'agenda'}
                definicoes={definicoesSistema?.seccoes ?? definicoesSistema?.servicos}
                setdefinicoes={setDefinicoesSistema}
                title={'Desabilitar/Habilitar agenda'}
                descricao={''}
            />
            <ButtonSwitchSistem
                url={'/definicoes/sistema/seccoes'}
                definicao={'noticias'}
                definicoes={definicoesSistema?.seccoes}
                setdefinicoes={setDefinicoesSistema}
                title={'Desabilitar/Habilitar noticias'}
                descricao={''}
            />
            <ButtonSwitchSistem
                url={'/definicoes/sistema/seccoes'}
                definicao={'destaques'}
                definicoes={definicoesSistema?.seccoes}
                setdefinicoes={setDefinicoesSistema}
                title={'Desabilitar/Habilitar destaques'}
                descricao={''}
            />
            <ButtonSwitchSistem
                url={'/definicoes/sistema/seccoes'}
                definicao={'artigos'}
                definicoes={definicoesSistema?.seccoes}
                setdefinicoes={setDefinicoesSistema}
                title={'Desabilitar/Habilitar artigos'}
                descricao={''}
            />
            <ButtonSwitchSistem
                url={'/definicoes/sistema/seccoes'}
                definicao={'links'}
                definicoes={definicoesSistema?.seccoes}
                setdefinicoes={setDefinicoesSistema}
                title={'Desabilitar/Habilitar links'}
                descricao={''}
            />
            <Divider />


            <Header header={'SECÇÃO DE SERVIÇOS'} />
            <ButtonSwitchSistem
                url={'/definicoes/sistema/servicos'}
                definicao={'informacoes'}
                definicoes={definicoesSistema?.servicos}
                setdefinicoes={setDefinicoesSistema}
                title={'Desabilitar/Habilitar informações'}
                descricao={''}
            />
            <ButtonSwitchSistem
                url={'/definicoes/sistema/servicos'}
                definicao={'agenda'}
                // definicoes={definicoesSistema?.servicos}
                definicoes={definicoesSistema?.servicos ?? definicoesSistema?.seccoes}
                setdefinicoes={setDefinicoesSistema}
                title={'Desabilitar/Habilitar marcação de agenda'}
                descricao={''}
            />
            <ButtonSwitchSistem
                url={'/definicoes/sistema/servicos'}
                definicao={'renovacaoAutorizacao'}
                definicoes={definicoesSistema?.servicos}
                setdefinicoes={setDefinicoesSistema}
                title={'Desabilitar/Habilitar renovação de autorização'}
                descricao={''}
            />
            <ButtonSwitchSistem
                url={'/definicoes/sistema/servicos'}
                definicao={'autorizados'}
                definicoes={definicoesSistema?.servicos}
                setdefinicoes={setDefinicoesSistema}
                title={'Desabilitar/Habilitar autorizados'}
                descricao={''}
            />
            <ButtonSwitchSistem
                url={'/definicoes/sistema/servicos'}
                definicao={'reclamacao'}
                definicoes={definicoesSistema?.servicos}
                setdefinicoes={setDefinicoesSistema}
                title={'Desabilitar/Habilitar reclamação'}
                descricao={''}
            />
            <ButtonSwitchSistem
                url={'/definicoes/sistema/servicos'}
                definicao={'estabelecimentosLicenciados'}
                definicoes={definicoesSistema?.servicos}
                setdefinicoes={setDefinicoesSistema}
                title={'Desabilitar/Habilitar lista actualizada de estabelicementos licenciados'}
                descricao={''}
            />
            <ButtonSwitchSistem
                url={'/definicoes/sistema/servicos'}
                definicao={'importacaoExportacao'}
                definicoes={definicoesSistema?.servicos}
                setdefinicoes={setDefinicoesSistema}
                title={'Desabilitar/Habilitar importação e exportação'}
                descricao={''}
            />
            <ButtonSwitchSistem
                url={'/definicoes/sistema/servicos'}
                definicao={'certificadoProdutosControlados'}
                definicoes={definicoesSistema?.servicos}
                setdefinicoes={setDefinicoesSistema}
                title={'Desabilitar/Habilitar solicitação de certificado de produtos controlados'}
                descricao={''}
            />
            <ButtonSwitchSistem
                url={'/definicoes/sistema/servicos'}
                definicao={'desalfandegamento'}
                definicoes={definicoesSistema?.servicos}
                setdefinicoes={setDefinicoesSistema}
                title={'Desabilitar/Habilitar solicitação de desalfandegamento'}
                descricao={''}
            />
            <ButtonSwitchSistem
                url={'/definicoes/sistema/servicos'}
                definicao={'analiseLaboratorial'}
                definicoes={definicoesSistema?.servicos}
                setdefinicoes={setDefinicoesSistema}
                title={'Desabilitar/Habilitar solicitação de nalise laboratorial'}
                descricao={''}
            />
            <ButtonSwitchSistem
                url={'/definicoes/sistema/servicos'}
                definicao={'farmacovigilancia'}
                definicoes={definicoesSistema?.servicos}
                setdefinicoes={setDefinicoesSistema}
                title={'Desabilitar/Habilitar farmacovigilância'}
                descricao={''}
            />
            <ButtonSwitchSistem
                url={'/definicoes/sistema/servicos'}
                definicao={'registosMedicamentos'}
                definicoes={definicoesSistema?.servicos}
                setdefinicoes={setDefinicoesSistema}
                title={'Desabilitar/Habilitar registo de medicamentos'}
                descricao={''}
            />
            <Divider />


            <br />
            <VerifyPermission permissions={user?.permissions} permission={'gestQuota'}>
                <Header header={'OUTRAS DEFINIÇÕES'} />
                <GestQuota />
            </VerifyPermission>
            {/* <Divider /> */}
        </>
    )
}
